const HeroSection = () => {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20artistic%20flat%20lay%20composition%20featuring%20fashion%20moodboard%20with%20fabric%20swatches%20in%20warm%20terracotta%20and%20sand%20tones%20scattered%20across%20textured%20cream%20paper%2C%20delicate%20dried%20botanicals%20and%20eucalyptus%20sprigs%2C%20vintage%20brass%20scissors%2C%20aesthetic%20polaroid%20photos%20arranged%20organically%2C%20soft%20natural%20window%20light%20casting%20gentle%20shadows%2C%20editorial%20creative%20studio%20atmosphere%2C%20artistic%20and%20inspiring%2C%20warm%20earthy%20palette%2C%20no%20text%20visible%2C%20sophisticated%20lifestyle%20branding%20photography&width=1800&height=1200&seq=hero-v2-main-bg-2026&orientation=landscape"
          alt="Hipobuy Spreadsheet product research and shopping resources"
          title="Hipobuy Spreadsheet - Product Research Hub"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/25 to-black/15"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20 py-32 md:py-40">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-white/90 text-sm font-medium">Updated Daily · 14 Categories Covered</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
            Hipobuy Spreadsheet
            <br />
            <span className="text-accent-400">The Ultimate Resource Hub</span>
            <br />
            <span className="text-white/80">For Smart Shopping</span>
          </h1>

          <p className="text-white/75 text-base md:text-lg max-w-2xl leading-relaxed mb-10">
            Discover curated Hipobuy Spreadsheet resources, product research guides, comparison tools and expert shopping insights designed to help global buyers find products faster and make better decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              Explore Hipobuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-white text-foreground-900 text-base font-semibold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-6 mt-12 pt-10 border-t border-white/15">
            {[
              { icon: 'ri-check-line', text: 'Updated Resources' },
              { icon: 'ri-user-heart-line', text: 'Beginner Friendly Guides' },
              { icon: 'ri-scales-3-line', text: 'Product Comparison Tables' },
              { icon: 'ri-shield-check-line', text: 'Shopping Safety Information' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-white/80 text-sm">
                <i className={item.icon}></i>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;